"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname, useSearchParams } from "next/navigation";
import posthog from "posthog-js";
import { PostHogProvider as PostHogProviderOriginal, usePostHog } from "posthog-js/react";
import { Suspense, useEffect } from "react";
function PostHogPageView() {
  const $ = _c(5);
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const posthog = usePostHog();
  let t0;
  let t1;
  if ($[0] !== pathname || $[1] !== posthog || $[2] !== searchParams) {
    t0 = () => {
      if (pathname && posthog) {
        let url = window.origin + pathname;
        if (searchParams.toString()) {
          url = url + "?" + searchParams.toString();
        }
        posthog.capture("$pageview", {
          $current_url: url
        });
      }
    };
    t1 = [pathname, searchParams, posthog];
    $[0] = pathname;
    $[1] = posthog;
    $[2] = searchParams;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  return null;
}

// Wrap PostHogPageView in Suspense to avoid the useSearchParams usage above
// from de-opting the whole app into client-side rendering
// See: https://nextjs.org/docs/messages/deopted-into-client-rendering
function SuspendedPostHogPageView() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Suspense fallback={null}><PostHogPageView /></Suspense>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export default function PostHogProvider(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp, t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SuspendedPostHogPageView />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <PostHogProviderOriginal client={posthog}>{t2}{children}</PostHogProviderOriginal>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
function _temp() {
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY as string, {
    api_host: "/ingest",
    ui_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    person_profiles: "always",
    capture_pageview: false,
    capture_pageleave: true
  });
}